export default {
  pages: {
    acquiringBalances: {
      title: `To'lovlar ro'yxati`,
      issueInvoice: 'Chekni taqdim qilish',
    },
  },
};
